import React, { Component } from 'react'

export default class DocumentLine extends Component {
    render() {
        return (
            <div className='history-line smr-table-line'>
                <div>{ this.props.item.regNum + (this.props.item.batchVersion < 2 ? '' : (' в.' + this.props.item.batchVersion)) }</div>
                <div>{ this.props.item.regDate }</div>
                <div>
                    <button
                        onClick={ _=> this.props.OnReloadClicked(this.props.item) }
                        className="download-document-button">Перезагрузить</button>
                </div>
            </div>
        )
    }
}